import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getBalance = createAsyncThunk(
  "student/getBalance",
  async ({ typeFilter,searchData,archiveFilter }, { rejectWithValue }) => {
    try {
      let url = `/balance/all?typeFilter=${typeFilter}`;
      if (searchData) {
        url += `&search=${searchData}`;
      }
      if (archiveFilter) {
        url += `&archiveFilter=${archiveFilter}`;
      }
      const response = await apiInstance.get(url, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const editWithdraw = createAsyncThunk(
  "student/editBalance",
  async (payload, { rejectWithValue }) => {
    try {
      let url = `/balance/edit`;
      const response = await apiInstance.post(url,payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  balanceData: null,
};

const balanceSlice = createSlice({
  name: "balanceSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBalance.fulfilled, (state, action) => {
      state.balanceData = action.payload.data;
    });
  },
});

export default balanceSlice.reducer;
